import StatBoard from "../../../../utils/game/mechanics/StatBoard";
import FlexColumn from "../../../../common/components/layout/Flexbox/FlexColumn";
import Tooltip from "../../../../common/components/wrappers/Tooltip/Tooltip";
import { StatKeyMap } from "../../../../utils/game/mechanics/StatKeyMap";
import { ReactElement, useMemo } from "react";

import "./AttributePanel_style.css";

type Props = Readonly<{
    statBoard: StatBoard;
    statKey: string;
    qualifiers?: Array<string> | null,
    onAttributeTitleClick?: () => void;
}>;

export default function AttributePanel({
    statBoard,
    statKey,
    qualifiers = null,
    onAttributeTitleClick
}: Props): ReactElement {
    const score = statBoard.getValueByStatKey(statKey, qualifiers);

    const scoreTips = statBoard.getTipsByStatKey(statKey, qualifiers, null, true);

    return (
        <FlexColumn className="attribute-panel-container">
            <div className="title" onClick={onAttributeTitleClick}>{StatKeyMap.get(statKey) ?? statKey}</div>
            <Tooltip
                tooltipContent={scoreTips}
                enabled={scoreTips.length > 0}
                direction="auto-above-below"
            >
                <div className="score-container">
                    <div className="score">{score}</div>
                </div>
            </Tooltip>
        </FlexColumn>
    );
}
